import { ArrowIcon, PenIcon, PlusIcon } from '@src/Components/Icons';
import React from 'react';
import styles from './ButtonDefault.module.scss';
import { ButtonDefaultProps } from './ButtonDefault.type';

const ButtonDefault: React.FC<ButtonDefaultProps> = ({
  label = 'Button',
  onClick,
  customStyle,
  icon,
  withIcon = false,
  disabled = false,
  variant = 'red',
  background = 'filled'
}) => {
  return (
    <button
      data-testid="button-default"
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      data-background={background}
      className={`${styles['Container']} ${
        customStyle && styles[customStyle]
      } ${withIcon && styles['with-icon']} ${styles[variant]} 
      } ${disabled && styles['disabled']}`}
    >
      {withIcon && (
        <div className={styles['icon-wrapper']}>
          {icon === 'add' && <PlusIcon />}
          {icon === 'arrow' && <ArrowIcon />}
          {icon === 'edit' && (
            <PenIcon color={disabled ? '#232A31' : undefined} />
          )}
        </div>
      )}
      {label}
    </button>
  );
};

export default ButtonDefault;
